export const superShotPage = {
    content: () => import('./SuperShotPage.vue'),
};
